// The Honour Row: students who completed with an overall average of 90% or above.
// Managed via the CMS. Names, averages, destinations and portraits must come from MCC records
// and be published with each student's consent. Cohorts with no records yet render a preview.

export type Honouree = {
  name: string;
  initials: string;
  average: number;
  destination?: string;
  image?: string;
};

export type Cohort = {
  year: string;
  honourees: Honouree[];
};

export const HONOUR_THRESHOLD = 90;

export const COHORTS: Cohort[] = [
  { year: "2025–26", honourees: [] },
  { year: "2024–25", honourees: [] },
  { year: "2023–24", honourees: [] },
  { year: "2022–23", honourees: [] },
  { year: "2021–22", honourees: [] },
  { year: "2020–21", honourees: [] },
  { year: "2019–20", honourees: [] },
];
